import _classCallCheck from "/Users/och/Downloads/contentlab_frontend-main-1/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/och/Downloads/contentlab_frontend-main-1/node_modules/@babel/runtime/helpers/esm/createClass";
import _get from "/Users/och/Downloads/contentlab_frontend-main-1/node_modules/@babel/runtime/helpers/esm/get";
import _getPrototypeOf from "/Users/och/Downloads/contentlab_frontend-main-1/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/Users/och/Downloads/contentlab_frontend-main-1/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/Users/och/Downloads/contentlab_frontend-main-1/node_modules/@babel/runtime/helpers/esm/createSuper";
import { TiltAnimation } from "./TiltAnimation";
import { ValueWithRandom } from "../../ValueWithRandom";
export var Tilt = /*#__PURE__*/function (_ValueWithRandom) {
  _inherits(Tilt, _ValueWithRandom);
  var _super = _createSuper(Tilt);
  function Tilt() {
    var _this;
    _classCallCheck(this, Tilt);
    _this = _super.call(this);
    _this.animation = new TiltAnimation();
    _this.direction = "clockwise";
    _this.enable = false;
    _this.value = 0;
    return _this;
  }
  _createClass(Tilt, [{
    key: "load",
    value: function load(data) {
      if (!data) {
        return;
      }
      _get(_getPrototypeOf(Tilt.prototype), "load", this).call(this, data);
      this.animation.load(data.animation);
      if (data.direction !== undefined) {
        this.direction = data.direction;
      }
      if (data.enable !== undefined) {
        this.enable = data.enable;
      }
    }
  }]);
  return Tilt;
}(ValueWithRandom);